import React, { useEffect } from "react";
import { Controller } from "react-hook-form";

export default function Documentation({
  register,
  errors,
  watch,
  setValue,
  control,
  updateData,
  clearErrors,
}) {
  // Define the checkbox options in an array for easy mapping.
  const documentOptions = [
    {
      id: "valid_Canadian_Passport",
      name: "valid_canadian_passport",
      label: "Valid Passport",
      defaultChecked: true,
    },
    {
      id: "canadianCitizenshipOrPRCard",
      name: "canadian_citizenship_or_prCard",
      label: "Canadian Citizenship/PR Card",
      defaultChecked: true,
    },
    {
      id: "validTravelVisa",
      name: "valid_travel_visa",
      label: "Valid Travel Visa",
      defaultChecked: true,
    },
    // {
    //   id: "touristCard",
    //   name: "tourist_card",
    //   label: "Tourist Card",
    // },
  ];

  const defaultSpecialRemarks = `CHECK-IN 3 HOURS BEFORE DEPARTURE. TICKET IS AN E-TICKET. SUBJECT TO OPERATOR'S TERMS AND CONDITIONS. IT IS THE CUSTOMER'S RESPONSIBILITY TO ENSURE THEY HAVE APPROPRIATE TRAVEL DOCUMENTATION. REVIEW ITINERARY TO ENSURE ALL INFORMATION IS CORRECT.
An administration charge of CAD $300.00 will apply to all tickets returned for refund or reissue, in addition to any airline charge.
I, the undersigned, will not hold my travel agent or travel agency responsible for any expenses incurred as a result of my refusal to purchase the travel insurance, and I also understand the conditions of the tickets.
* Please reconfirm return/onward booking 72 hours before travel.
* Entry to another country may be refused even if the required information and travel documents are complete.
* Returning to Canada, Immigration needs a PR Card/Citizenship.`;

  const defaultInsuranceRemarks =
    "Insurance offered, but declined the purchase of Trip Cancellation and Medical/Health Insurance. Trip Cancellation and Medical/Health Insurance are available to purchase elsewhere. No price increases are permitted after the customer has paid in full. Living standards and practices at the destination and the standards and conditions there with respect to the provision of utilities, services, and accommodation may differ from those found in Canada.";

  return (
    <section className="bg-[#e5f4df] p-4">
      <h2 className="text-md bg-[#c7ddbe] px-2 py-1 font-semibold text-black">
        Documentation and Remarks
      </h2>
      <div className="px-2 py-2 text-sm text-black">
        <p className="mb-2">Travel Documents Required:</p>
        <div className="flex flex-col space-y-1">
          {documentOptions.map((doc) => (
            <div key={doc.id} className="flex items-center">
              <Controller
                control={control}
                name={doc.name}
                defaultValue={doc.defaultChecked || false}
                render={({ field: { onChange, value, ref } }) => (
                  <input
                    type="checkbox"
                    id={doc.id}
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                    ref={ref}
                  />
                )}
              />
              <label
                htmlFor={doc.id}
                className="ml-2 cursor-pointer font-light"
              >
                {doc.label}
              </label>
            </div>
          ))}
          <div>
            <label
              htmlFor="special-remarks"
              className="cursor-pointer font-light"
            >
              Special Remarks
            </label>
            <textarea
              id="special-remarks"
              className="w-full rounded border border-gray-600 bg-white p-2 text-black focus:border-blue-500 focus:outline-none"
              rows={10}
              defaultValue={defaultSpecialRemarks}
              {...register("special_remarks")}
            />
          </div>
          <div>
            <label
              htmlFor="other-remarks"
              className="cursor-pointer font-light"
            >
              Insurance/Other Remarks
            </label>
            <textarea
              id="other-remarks"
              className="w-full rounded border border-gray-600 bg-white p-2 text-black focus:border-blue-500 focus:outline-none"
              rows={5}
              defaultValue={defaultInsuranceRemarks}
              {...register("other_remarks")}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
